/**************************************************
 * Nombre:       Formulario_Evento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccessTime,
    BadgeOutlined,
    CalendarMonth,
    EditAttributes,
    Flag,
    Google, GroupOutlined, LinkOutlined, NotificationAdd, NotificationAddOutlined,
    TitleOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSEVENTO, ESTADOSUSUARIOS} from "../../Constantes";
import IngresoCheckGrupo from "../../Modulo_formularios/Componentes/IngresoCheckGrupo";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoHora from "../../Modulo_formularios/Componentes/IngresoHora";
import IngresoHoraSelect from "../../Modulo_formularios/Componentes/IngresoHoraSelect";

const Formulario_Evento = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Typography>Imagen 2x3 (maximo 300kb)</Typography>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={2} alto={3}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSEVENTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>

                </Grid>

                <Grid container size={6}>
                    <IngresoFecha Icono={CalendarMonth} nombre={'Fecha del evento'} dato={'fecha'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoHoraSelect  dato={'hora'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={3} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={EditAttributes} nombre={'Nombre Boton'} dato={'nombreBoton'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={LinkOutlined} nombre={'Link de Boton'} dato={'link'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={GroupOutlined} nombre={'Num Confirmados'} dato={'confirmados'} {...props}
                        type={'number'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={NotificationAdd} nombre={'Notificar Minutos Antes'} dato={'notificacion'} {...props}
                                  opciones={['Si', 'No']}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Evento